<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
  },
  mounted() {
    let _fun = () => {
      let isMobile = window.document.body.clientWidth < 800
      this.$store.commit('setMobile', isMobile)
      if (isMobile) {
        document.body.className = 'is-mobile'
      } else {
        document.body.className = ''
      }
    }
    _fun()
    window.addEventListener('resize', () => {
      _fun()
    })
  },
}
</script>
<style lang="less">
@import url(@/assets/font/iconfont.css);
</style>
